module.exports = __webpack_public_path__ + "img/vip_background_the_ckb.bdb02227.png";